import { memo } from 'react';

const CategoryTiles = memo(({ categories, onCategorySelect }) => {
  return (
    <div className="category-tiles-grid">
      {categories
        .filter(c => !c.isDeleted)
        .map((category) => (
          <button
            key={category.name}
            className="category-tile"
            onClick={() => onCategorySelect(category.name)}
            data-testid={`category-tile-${category.name}`}
          >
            <div className="category-tile__image-wrapper">
              {category.menuTileImageUrl ? (
                <img
                  src={category.menuTileImageUrl}
                  alt={category.name}
                  className="category-tile__image"
                  loading="lazy"
                />
              ) : (
                <div className="category-tile__placeholder" />
              )}
              <div className="category-tile__gradient" />
            </div>
            {!category.hideCategoryNameOnTile && (
              <div className="category-tile__label">
                <span>{category.name}</span>
              </div>
            )}
          </button>
        ))}
    </div>
  );
});

CategoryTiles.displayName = 'CategoryTiles';
export default CategoryTiles;
